import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { jwtDecode } from 'jwt-decode';

@Injectable({
  providedIn: 'root',
})
export class HttpService {
  constructor(private http: HttpClient) {}

  post<T>(url: string, body: object = {}) {
    return this.http.post<T>(url, body);
  }

  get<T>(url: string, params = null) {
    return params ? this.http.get<T>(url, params) : this.http.get<T>(url);
  }

  delete<T>(url: string, params = null) {
    return params ? this.http.delete<T>(url, params) : this.http.delete<T>(url);
  }

  put<T>(url: string, body: object = {}) {
    return this.http.put<T>(url, body);
  }

  patch<T>(url: string, body) {
    return this.http.patch<T>(url, body);
  }

  decodeToken(token: string) {
    try {
      const data = jwtDecode(token);
      delete data['iat'];
      delete data['nbf'];

      return Object.values(data);
    } catch (error) {
      throw error;
    }
  }

  decryptToken(token: string) {
    try {
      const data = jwtDecode(token);
      delete data['iat'];
      delete data['nbf'];

      return data;
    } catch (error) {
      throw error;
    }
  }

  decodeUserToken(token: string) {
    try {
      const data = jwtDecode(token);
      delete data['iat'];
      delete data['nbf'];
      return Object.values(data);
    } catch (error) {
      throw error;
    }
  }

  normalDecode(token: string) {
    try {
      const data = jwtDecode(token);
      delete data['iat'];
      delete data['nbf'];
      return data['@xano'];
    } catch (error) {
      throw error;
    }
  }

  decodeLoginToken(token: string) {
    try {
      const data = jwtDecode(token);
      return data;
    } catch (error) {
      throw error;
    }
  }
  decodeTokenPagination(token: string) {
    try {
      const data = jwtDecode(token);
      return data;
    } catch (error) {
      throw error;
    }
  }

  decodeTest(token: string) {
    try {
      const data: any = jwtDecode(token);
      delete data['iat'];
      delete data['nbf'];
      return Object.values(data);
    } catch (error) {
      throw error;
    }
  }

  decodeTokenPaginationWithcondition(token: string) {
    try {
      const data: any = jwtDecode(token);
      delete data['iat'];
      delete data['nbf'];
      return data.items && data.pageTotal ? data : Object.values(data);
    } catch (error) {
      throw error;
    }
  }

  decodeUserAssignmentToken(token: string) {
    try {
      const data: any = jwtDecode(token);
      delete data['iat'];
      delete data['nbf'];
      return data.items && data.pageTotal
        ? this.decodeTokenPagination(token)
        : data?.items && data?.pageTotal === 0
        ? data
        : Object.values(data);
    } catch (error) {
      throw error;
    }
  }
}
